import React from 'react';
import ReactDOM from 'react-dom';
import { Field,reduxForm } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../components/LoadingSmall.js';
import axios from 'axios';

class Mystore extends React.Component {
    constructor(props) {
        super(props);

        this.language = {};
        this.language['norwegian'] = {
            address:'Adresse',
            step1_title:"Web adresse",
            step1_description:"Hva er adressen til nettbutikken din?",
            continue:'Fortsett',
            step2_title:"Pin-kode",
            step2_description_1:"Det er sendt en PIN-kode til ",
            step2_description_2:"Hent koden og skriv den inn koden i feltet under.",
            validate_pin:'Verifiser PIN-kode',
            get_pin:'Hent PIN-kode',
        }

        this.language['english'] = {
            address:'Url',
            step1_title:"URL",
            step1_description:"What is the url for your shop?",
            continue:'Continue',
            step2_title:"Pin-code",
            step2_description_1:"We sent a PIN-code to ",
            step2_description_2:"Get your PIN-code and type it in the field below.",
            validate_pin:'Verify PIN-code',
            get_pin:'Get PIN-code',
        }

        this.state = {
            error:false,
            info:false,
            isLoading:false,
            step:1,
            email:'',
            url:'',
            pin:'',
        }

        this.getPin = this.getPin.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.step1 = this.step1.bind(this);
        this.step2 = this.step2.bind(this);
        this.checkPin = this.checkPin.bind(this);
    }

    checkPin() {
        this.setState({'isLoading':true});
        axios.post('/ajax/Mystore_check_pin',{url:this.state.url,'pin':this.state.pin}).then(res => {
            this.props.handleComplete();
        }).catch(err => {
            
            this.setState({'error':err.response.data.error.message,isLoading:false});
        });
    }

    step1() {
        return (
            <div>
                <h1>{this.getLanguage('step1_title')}</h1>
                <span className="description">{this.getLanguage('step1_description')}</span>

                {this.state.error ? 
                <div className="m-t-10 m-b-10">
                    <div className="alert dark alert-icon alert-danger alert-dismissible" role="alert">
                        <i className="icon wb-close" aria-hidden="true"></i> {this.state.error}
                    </div>
                </div>:null}

                {this.state.info ? 
                <div className="m-t-10 m-b-10">
                    <div className="alert dark alert-icon alert-warning alert-dismissible" role="alert">
                        <i className="icon wb-alert" aria-hidden="true"></i> {this.state.info}
                    </div>
                </div>:null}

                <div className="m-t-20">
                    
                     <div className="form-group col-sm-12">
                        <label className="form-control-label">{this.getLanguage('address')}</label>
                        <input type="text" data-id="url" placeholder="www.myshop.com" className="form-control form-control-lg" value={this.state.url} onChange={this.handleInputChange} />
                    </div>

                </div>

                {this.state.isLoading ?
                <div className="m-t-20 col-sm-12 text-center">
                    <LoadingSmall />
                </div>
                :
                <div className="m-t-20 col-sm-12 text-center">
                    <button className="btn btn-dark btn-lg" onClick={this.getPin} type="button">{this.getLanguage('get_pin')} <i className="icon wb-arrow-right"></i></button>
                </div>
                }
            </div>
        )
    }

    step2() {
        return (
            <div>
                <h1>{this.getLanguage('step2_title')}</h1>
                <span className="description">{this.getLanguage('step2_description_1')} <strong>{this.state.email}</strong>.<br />{this.getLanguage('step2_description_2')}</span>

                {this.state.error ? 
                <div className="m-t-10 m-b-10">
                    <div className="alert dark alert-icon alert-danger alert-dismissible" role="alert">
                        <i className="icon wb-close" aria-hidden="true"></i> {this.state.error}
                    </div>
                </div>:null}

                {this.state.info ? 
                <div className="m-t-10 m-b-10">
                    <div className="alert dark alert-icon alert-warning alert-dismissible" role="alert">
                        <i className="icon wb-alert" aria-hidden="true"></i> {this.state.info}
                    </div>
                </div>:null}

                <div className="m-t-20">
                    
                     <div className="form-group col-sm-12">
                        <label className="form-control-label">{this.getLanguage('step2_title')}</label>
                        <input type="text" data-id="pin" placeholder="1234" className="form-control text-center form-control-lg" value={this.state.pin} onChange={this.handleInputChange} />
                    </div>

                </div>

                {this.state.isLoading ?
                <div className="m-t-20 col-sm-12 text-center">
                    <LoadingSmall />
                </div>
                :
                <div className="m-t-20 col-sm-12 text-center">
                    <button className="btn btn-dark btn-lg" onClick={this.checkPin} type="button">{this.getLanguage('validate_pin')} <i className="icon wb-arrow-right"></i></button>
                </div>
                }
            </div>
        )
    }   

    getPin() {
        this.setState({'isLoading':true});
        axios.post('/ajax/Mystore_get_pin',{'url':this.state.url}).then(res => {
            this.setState({'error':false,isLoading:false,email:res.data.email,step:2});
        }).catch(err => {
            this.setState({'error':err.response.data.error.message,isLoading:false});
        });
    }

    handleInputChange(e) {
        let val = e.target.value;

        if(e.target.getAttribute('data-id') == 'pin') {
            if(val.length >= 5) {
                return;
            }
        }


        this.setState({
            [e.target.getAttribute('data-id')]:val
        });
    }

    getLanguage(str) {
        return this.language[this.props.language][str];
    }
   
    render() {
        return (
                <div>{this.state.step == 1 ? this.step1():this.step2()}</div>

        );
    }
}

const mapStateToProps = (state, ownProps) => ({

});

export default Mystore;



// WEBPACK FOOTER //
// ./containers/setup/Platform/Mystore.js